"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_url_1 = require("owa-url");
var hostLocation_1 = require("owa-url/lib/hostLocation");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var showCalendar = legacy_1.action('showCalendar')(function showCalendar(newWindow) {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    // switch to calendar module
    var calendarUrl = owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
        ? hostLocation_1.getHostLocation()
            .href.replace(hostLocation_1.getHostLocation().hash, '')
            .replace(hostLocation_1.getHostLocation().pathname, owa_url_1.getCalendarPath())
        : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' });
    newWindow.open(calendarUrl, '_self');
    return Promise.resolve();
});
exports.default = showCalendar;
//# sourceMappingURL=showCalendar.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/actions/showCalendar.js
// module id = 5809
// module chunks = 96